import { UserContext } from '../contexts/contexts';

export const User = ({ children, values }) => (
  <UserContext.Provider value={values}>{children}</UserContext.Provider>
);
